function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtAndDesign = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.149,
    y: 0.098,
    width: 44,
    height: 44,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.149,22.098L40.149,22.288C40.121,24.854 37.786,26.598 35.22,26.598L28.336,26.598C26.473,26.598 24.961,28.11 24.961,29.973C24.961,30.212 24.989,30.444 25.032,30.669C25.179,31.386 25.489,32.076 25.791,32.772C26.22,33.742 26.642,34.705 26.642,35.725C26.642,37.961 25.123,39.993 22.887,40.084C22.641,40.091 22.395,40.098 22.142,40.098C12.207,40.098 4.149,32.04 4.149,22.098C4.149,12.156 12.207,4.098 22.149,4.098C32.091,4.098 40.149,12.156 40.149,22.098ZM13.149,24.348C13.149,23.104 12.143,22.098 10.899,22.098C9.654,22.098 8.649,23.104 8.649,24.348C8.649,25.593 9.654,26.598 10.899,26.598C12.143,26.598 13.149,25.593 13.149,24.348ZM13.149,17.598C14.393,17.598 15.399,16.593 15.399,15.348C15.399,14.104 14.393,13.098 13.149,13.098C11.904,13.098 10.899,14.104 10.899,15.348C10.899,16.593 11.904,17.598 13.149,17.598ZM24.399,10.848C24.399,9.604 23.393,8.598 22.149,8.598C20.904,8.598 19.899,9.604 19.899,10.848C19.899,12.093 20.904,13.098 22.149,13.098C23.393,13.098 24.399,12.093 24.399,10.848ZM31.149,17.598C32.393,17.598 33.399,16.593 33.399,15.348C33.399,14.104 32.393,13.098 31.149,13.098C29.904,13.098 28.899,14.104 28.899,15.348C28.899,16.593 29.904,17.598 31.149,17.598Z",
    style: {
      fill: "#00659d",
      fillRule: "nonzero"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtAndDesign);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-and-design.429383495aa38a0ee52965ae442e5236.svg";